import CustomiseReport from "components/CustomiseReport/CustomiseReport";
import ReportDetails from "components/ReportDetails/ReportDetails";
import ReportingPeriod from "components/ReportingPeriod/ReportingPeriod";
import { useLayoutEffect } from "react";
import { Route, Routes, useLocation } from "react-router";

export const event = "event";
export const eventCategory = "eventCategory";
export const eventAction = "eventAction";
export const eventLabel = "eventLabel";

function App() {
  const location = useLocation();

  // Scroll to top of page if route changes
  useLayoutEffect(() => {
    const scrollBehaviour = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = "auto";
    window.scrollTo(0, 0);
    document.documentElement.style.scrollBehavior = scrollBehaviour;
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/" element={<ReportDetails />} />
      <Route path="/reportingperiod" element={<ReportingPeriod />} />
      <Route path="/customisereport" element={<CustomiseReport />} />
    </Routes>
  );
}

export default App;
